/**
 * Llamar a otro agente con @nombre (GEN-HU-033).
 *
 * La @ solo vale AL INICIO del mensaje y la valida el kernel (R-PT-04); aquí
 * solo se ayuda a escribirla: sugerir agentes activos al teclear «@» e insertar
 * «@Nombre » desde el panel «Agentes en este chat».
 */

const sinTildes = (s) => String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

/** Agentes a los que se puede llamar: los activos del tenant. */
export const llamables = (agents = []) => agents.filter(a => a.puede_iniciar_chat)

// «@» (con o sin espacios delante) seguida del nombre que se está tecleando.
const RE_TECLEANDO = /^\s*@([^\s,:;.!?¿¡@]*)$/

/** Si el texto es «@par…» sin terminar el nombre, devuelve el prefijo; si no, null. */
export function prefijoLlamada(texto) {
  const m = RE_TECLEANDO.exec(texto ?? '')
  return m ? m[1] : null
}

/** Sugerencias para el prefijo: activos cuyo nombre (o id) empieza por él. */
export function sugerenciasLlamada(agents, prefijo) {
  if (prefijo == null) return []
  const p = sinTildes(prefijo)
  return llamables(agents).filter(a => sinTildes(a.nombre).startsWith(p) || sinTildes(a.id).startsWith(p))
}

/** Pone «@Nombre » al inicio del texto; si ya empezaba por una @x, la sustituye. */
export function conLlamada(texto, nombre) {
  const resto = String(texto ?? '').replace(/^\s*@[^\s,:;.!?¿¡@]*[,:;]?\s*/, '')
  return `@${nombre} ${resto}`
}

// «@Nombre» al inicio, con coma o dos puntos opcionales, y el resto del mensaje.
const RE_LLAMADA = /^\s*@([^\s,:;.!?¿¡@]+)[,:;]?\s*([\s\S]*)$/

/** Agente activo al que apunta la @ del inicio del texto (nombre o id exactos); null si no hay. */
export function agenteLlamado(texto, agents = []) {
  const m = RE_LLAMADA.exec(texto ?? '')
  if (!m) return null
  const n = sinTildes(m[1])
  return llamables(agents).find(a => sinTildes(a.nombre) === n || sinTildes(a.id) === n) ?? null
}

/** El mensaje sin la @Nombre del inicio (para abrir un hilo ya dirigido a ese agente). */
export function sinLlamada(texto) {
  const m = RE_LLAMADA.exec(texto ?? '')
  return (m ? m[2] : String(texto ?? '')).trim()
}
